import lidStaking from './abis/LidStaking.json';
import lidToken from './abis/LidToken.json';

const abis = {
  lidStaking: lidStaking,
  lidToken: lidToken
};

export default abis;
